import React from 'react';

export default function SearchBar({ value, onChange }) {
  return (
    <input
      type="search"
      className="form-control"
      style={{ minWidth: 240 }}
      placeholder="Search by ticket ID or subject"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label="Search tickets"
    />
  );
}
